import type {
  InsulinActivity,
  DeepPartial,
} from "@tandemdiabetes/sugarmate-api-react-client"
import dayjs from "dayjs"
import {
  useCallback,
  useEffect,
  useRef,
} from "react"
import type { DeepReadonlyObject } from "rxdb"

import { accountInsulinToActivityInsulin } from "./accountInsulinToActivityInsulin"
import { useNewestAccountInsulin } from "src/hooks"
import type { AccountInsulin } from "src/types"

export function useOnAccountInsulinCreated(
  activity: DeepPartial<InsulinActivity> | undefined,
  updateActivity: (a: DeepPartial<InsulinActivity>) => void,
) {
  const lastUpdatedRef = useRef<string>(dayjs().toISOString())
  const newestAccountInsulin = useNewestAccountInsulin()

  // this function updates the activity with the provided account insulin
  const updateActivityWithAccountInsulin = useCallback(
    (accountInsulin: DeepReadonlyObject<AccountInsulin>) => {
      updateActivity({
        num_units: activity?.insulin_med
          ? undefined
          : activity?.num_units,
        insulin_med: accountInsulinToActivityInsulin(accountInsulin),
      })
    },
    [
      activity,
      updateActivity,
    ],
  )

  useEffect(
    () => {
      if (
        newestAccountInsulin &&
        dayjs(newestAccountInsulin.created_at).isAfter(lastUpdatedRef.current)
      ) {
        updateActivityWithAccountInsulin(newestAccountInsulin)
        lastUpdatedRef.current = newestAccountInsulin.created_at
      }
    },
    [
      lastUpdatedRef,
      newestAccountInsulin,
      updateActivityWithAccountInsulin,
    ],
  )
}
